import { StepWizard } from "components/layouts";
import { FormikProps } from 'formik'
import { FC, useMemo, useState } from 'react'
import SummaryPage from './summary';
import AssignServiceOrderFormSteps from './form-steps';
import { ICreatePremiumServiceInterestFormSchema } from "./schema";

interface CreatePremiumServiceInterestFormProps {
  form: FormikProps<ICreatePremiumServiceInterestFormSchema>;
}

export const CreatePremiumServiceInterestForm: FC<CreatePremiumServiceInterestFormProps> = ({ form }) => {

  const filteredFormSteps = useMemo(
    () => {

      return AssignServiceOrderFormSteps
        .filter((_step) => Object.keys(form.values)
        .includes(_step.accessor))
        .map((_step, href) => ({..._step, href}))
        .filter((_step) => {
          return _step.requiresGenerateRAT ? form.values.interestInfo.generateRAT : true
        })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Object.keys(form.values), form.values.interestInfo.generateRAT]
  )

  const steps = useMemo(() => [
    ...filteredFormSteps,
    { name: 'Preview', FormComponent: SummaryPage, accessor: "summary" },
  ].map((rawStep, href) => ({ ...rawStep, href }))
    , [filteredFormSteps])

  const [step, setStep] = useState(0)
  const [lastStep, setLastStep] = useState(0)

  const onCancel = () => {
    setStep(0);
    setLastStep(0);
    form.resetForm();
  }

  const handleNextStep = (_step: string) => (_values: any) => {
    // check if last step
    form.setFieldValue(_step, _values)
    setStep(step + 1)
    setLastStep(step === lastStep ? (lastStep + 1) : lastStep)
  }

  const handlePreviousStep = () => {
    setStep(step - 1)
  }

  const handleCancel = () => {
    form.resetForm();
    onCancel();
  }

  const renderForm = () => {

    let StepContent = steps[step || 0];

    if(!StepContent){
      StepContent = steps[steps.length - 1];
    }

    const { FormComponent, accessor } = StepContent;

    return <FormComponent
      handleNext={handleNextStep(accessor)}
      initialValues={(form.values as any)[accessor]}
      values={form.values}
      handlePrevious={handlePreviousStep}
      handleCancel={handleCancel}
      handleStep={setStep}
      handleSubmit={form.handleSubmit}
      submitLoading={form.isSubmitting}
      steps={filteredFormSteps}
    />
  }

  return (
    <div className='bg-white dark:bg-gray-900 shadow-xl flex flex-col flex-1 overflow-hidden relative'>
      <div className='px-6 pt-6'>
        <StepWizard
          steps={steps}
          step={step}
          setStep={setStep}
          lastStep={lastStep}
        />
      </div>
      <div className='flex flex-1 overflow-hidden'>
        {renderForm()}
      </div>
    </div>
  )
}

export default CreatePremiumServiceInterestForm
